import { AssetProperty } from '../../shared/services/api/model/assetProperty';

export class GetProperties {
    public static readonly type = '[Asset Details] Get Properties';
}

export class GetPropertyValues {
    public static readonly type = '[Asset Details] Get Property Values';
    constructor() {}
}

export class GetLastKnownAssetTelemetryValues {
    public static readonly type = '[Asset Details] Get Telemetries Lastest Values';
    constructor() {}
}

export class SetPropertyValues {
    public static readonly type = '[Asset Details] Set Property Values';

    constructor(
        public properties: object,
        public force = false
    ) {}
}

export class PushProperty {
    public static readonly type = '[Asset Details] Push Property';

    constructor(public data: AssetProperty[]) {}
}
